<template>
  <div class="login x-flex x-row-around x-col-start">
    <img class="" src="../assets/img/login_text.png">
    <!-- 续费 -->
    <mallRenew :isShow='showMallRebew' @cencal='fCloseRenew' :canClose='canClose' :mallId='login.shMallId'
      :mallStopDay='mallStopDay' :shPhone='login.shPhone'></mallRenew>
    <!-- 登录窗口 -->
    <div class="left-login x-flex x-h100p x-row-center" style="flex-direction: column;">
      <div class="login-box bgc-f x-text-c x-flex x-row-between" style="flex-direction: column;">
        <div class="x-w100p">
          <div class="x-font-26 x-p-t-10 x-p-b-30 ">欢迎回来</div>
          <!-- <div class="x-flex x-w100p x-row-center c-80 x-font-16">
            <div class='x-flex-1 x-p-t-8 x-p-b-8 x-bd  x-cur-poi' style='border-radius: 3px 0 0 3px;'
              @click='active="普通登录"' :class='active=="普通登录"?"isActive":""'>普通登录</div>
            <div class='x-flex-1 x-p-t-8 x-p-b-8 x-bd  x-cur-poi' style='border-radius:  0 3px 3px 0;'
              @click='active="快捷登录"' :class='active=="快捷登录"?"isActive":""'>快捷登录</div>
          </div> -->
        </div>
        <!-- <div class='x-p-t-40 x-w100p'> -->
        <div class='x-p-t-20 x-w100p'>
          <el-input clearable ref='shPhone' prefix-icon="el-icon-mobile-phone"
            @keydown.enter.native="fChgFous('shPhone')" :class="!api.smCom.fSmIsEmpty( errMsg.shPhone)?'':'x-m-b-10' "
            v-model="login.shPhone" @change="fGetMallList(true,'mr')" :placeholder="active=='普通登录'?'商户绑定手机号':'请输入手机号'">
          </el-input>
          <div v-if='!api.smCom.fSmIsEmpty( errMsg.shPhone)' class="err x-w80p x-text-l">{{errMsg.shPhone}}</div>
        </div>
        <div class='x-p-t-10 x-w100p'>
          <!-- <el-input clearable prefix-icon="el-icon-school"
            :class="!api.smCom.fSmIsEmpty( errMsg.shMallId)?'':'x-m-b-10' " v-model="login.shMallId"
            placeholder="请选择登录门店">
          </el-input> -->
          <el-select class="x-w100p" ref='shMall' v-model="login.shMallId" placeholder="请选择登录门店"
            @visible-change='fGetMallList' @change="fChgMall">
            <i slot="prefix" class="el-icon-school x-p-t-11 x-p-l-4" />
            <el-option v-for="item in mallList" :key="item.mall_id" :label="item.mall_name" :value="item.mall_id">
              <div class="x-flex">
                <div class='x-w140'>{{item.mall_name}}</div>
                <div class='x-w140'>{{item.mall_id}}</div>
              </div>
            </el-option>
          </el-select>
          <div v-if='!api.smCom.fSmIsEmpty( errMsg.shMallId)' class="err x-w80p x-text-l">{{errMsg.shMallId}}</div>
        </div>
        <!-- <div class='x-p-t-40 '>
          <el-input clearable prefix-icon="el-icon-mobile-phone"
            :class="!api.smCom.fSmIsEmpty( errMsg.shPhone)?'':'x-m-b-10' " v-model="login.shPhone"
            placeholder="请输入手机号"></el-input>
          <div v-if='!api.smCom.fSmIsEmpty( errMsg.shPhone)' class="err x-w80p x-text-l">{{errMsg.shPhone}}</div>
        </div> -->
        <!-- 普通登录 -->
        <div class="x-w100p x-flex-1" v-if="active=='普通登录'">

          <div class='x-p-t-20'>
            <el-input clearable ref='userId' prefix-icon="el-icon-user" @keydown.enter.native="fChgFous('userId')"
              :class="!api.smCom.fSmIsEmpty( errMsg.userId)?'':'x-m-b-10' " v-model="login.userId" placeholder="登陆员工工号">
            </el-input>
            <div v-if='!api.smCom.fSmIsEmpty( errMsg.userId)' class="err x-w80p x-text-l">{{errMsg.userId}}</div>
          </div>
          <div class='x-p-t-10'>
            <el-input show-password ref='psw' prefix-icon="el-icon-lock" @keydown.enter.native="fChgFous('login')"
              :class="!api.smCom.fSmIsEmpty( errMsg.userPsw)?'':'x-m-b-10' " v-model="login.userPsw"
              placeholder="登录员工密码"></el-input>
            <div v-if='!api.smCom.fSmIsEmpty( errMsg.userPsw)' class="err x-w80p x-text-l">{{errMsg.userPsw}}</div>
          </div>
        </div>
        <!-- 快捷登录 -->
        <div class="x-w100p x-flex-1" v-if="active=='快捷登录'">

          <div class='x-p-t-20 '>
            <div class="x-flex" :class="!api.smCom.fSmIsEmpty( errMsg.yzm)?'':'x-m-b-10' ">
              <div class="x-flex-1">
                <el-input v-model="login.yzm" prefix-icon="el-icon-message" placeholder="请输入验证码"></el-input>
              </div>

              <div class="x-p-10 x-flex isActive x-rela" style="margin-left: -4px;border-radius: 0 3px 3px 0;z-index: 99;border: 1px solid #5890FF; border-bottom: none;
                -moz-user-select: none;
                -webkit-user-select: none;">
                <div>发送验证码</div>
              </div>

            </div>
            <div v-if='!api.smCom.fSmIsEmpty( errMsg.yzm)' class="err x-w80p x-text-l">{{errMsg.yzm}}</div>
            <!-- <div class="c-80">
            快捷登录默认登录为1001账号
            </div> -->
          </div>
        </div>
        <!-- 登录 -->
        <div class="x-w100p ">
          <!-- <div class="u-m-b-10">
            <el-radio v-model="verType" label="smSell5.0">零售版</el-radio>
            <el-radio v-model="verType" label="smCy3.0">餐饮版</el-radio>
          </div> -->
          <el-button style="width: 100%;font-size: 16px;" type="primary" @click='fLogin'>登录</el-button>

        </div>
      </div>
      <div class="x-p-t-20 c-f x-flex x-row-center">
        <!-- 注册 -->
        <div class="  ">
          还没有账号? <span style="text-decoration: underline;">立即注册</span>
        </div>
        <!-- <div class="x-flex">
          <el-checkbox v-model="isAgree"></el-checkbox>
          <div class="x-p-l-6 x-p-r-2 ">
            同意
          </div>
          <span style="text-decoration: underline;">用户协议</span>
        </div> -->


      </div>

    </div>


    <!-- 修改密码 -->
    <el-dialog class="manage" width="400px" :visible.sync="changePassword">
      <div class="x-w100p x-h50 x-lh-32 x-d-flex x-p-10-15 x-bd-bottom">
        <div class="x-lh-32 x-font-14 f600 c-80">请修改初始密码</div>
      </div>
      <div class="x-w100p x-p-20">
        <!-- 旧密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>旧密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="oldPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 新密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>新密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="newPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 确认密码 -->
        <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
          <div class="x-w70 x-d-flex x-row-right x-p-r-10">
            <div>确认密码</div>
          </div>
          <div class="x-flex-1 x-w100p">
            <el-input size="small" v-model="confirmPassword" placeholder="" show-password></el-input>
          </div>
        </div>
        <!-- 确定&取消 -->
        <div class="x-w100p x-h32 x-d-flex x-lh-32 x-row-right">
          <xButton width="70px" class="x-p-l-10" border="1px solid #DCDFE6" bgc="#fff" color="#242424"
            @click.native="changePassword = false">取消</xButton>
          <xButton width="70px" class="x-p-l-10" @click.native="determineAdd">确定</xButton>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import mallRenew from './mallRenew.vue'
  export default {
    components: {
      mallRenew
    },
    data() {
      return {
        // verType: this.$store.state.softVer == '餐饮' ? 'smCy3.0' : 'smSell5.0',
        //门店续费弹窗
        showMallRebew: false,
        canClose: 'Y',
        mallStopDay: '',
        // 存切换门店id的状态
        fei: 1,
        //选择登录方法
        active: '普通登录',
        //用户登录信息
        login: {
          shPhone: '',
          shMallId: '',
          userId: '',
          userPsw: '',
          yzm: '',
        },
        // 修改密码
        changePassword: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        //错误提示
        errMsg: {
          shPhone: '',
          shMallId: '',
          userId: '',
          userPsw: '',
          yzm: '',
        },
        mallList: [],
        // 用户协议
        isAgree: true,
        canLogin: 'N'
      }
    },
    created() {
      this.init()
      // this.fGetMallList()
    },
    methods: {
      init() {
        Object.assign(this.login, {
          shPhone: this.$store.state.smSellAdmin.shPhone,
          shMallId: this.$store.state.smSellAdmin.shMallId,
          userId: this.$store.state.smSellAdmin.userId,
          userPsw: '',
        })
        this.mallList = [{
            mall_name: this.$store.state.smSellAdmin.shMallName,
            mall_id: this.$store.state.smSellAdmin.shMallId
          }

        ]
      },
      //改变焦点
      fChgFous(ref) {
        if (ref == 'shPhone') {
          this.$nextTick(() => {
            this.$refs.shMall.focus()
          })
        }
        if (ref == 'userId') {
          this.$nextTick(() => {
            this.$refs.psw.focus()
          })
        }
        if (ref == 'login') {
          this.fLogin()
        }
      },
      //获取门店
      async fGetMallList(show, type) {
        if (!show) {
          return
        }
        // 清空
        Object.assign(this.login, {
          shMallId: '',
          userId: '',
          userPsw: '',
        })
        this.mallList = []
        this.$store.commit('shMallId', '')
        this.$store.commit('shMallName', '')
        this.$store.commit('userId', '')
        this.$store.commit('userName', '')
        if (this.api.smCom.fSmIsEmpty(this.login.shPhone)) {
          return this.$message.error('请输入商户绑定手机号')
        }
        //登录之前获取门店url
        // if (this.login.shPhone != this.$store.state.smSellAdmin.shPhone) {
        let resUrl = await this.fGetMainSrvMchInfo()
        if (resUrl.result != "sucess") {
          return this.$message.error(resUrl.msg)
        }
        if (this.api.smCom.fSmIsEmpty(resUrl.data[0].load_url)) {
          return this.$message.error('获取商户地址失败')
        }
        //储存url和手机号至本地
        this.$store.commit('shPhone', this.login.shPhone)
        this.$store.commit('shLoadUrl', resUrl.data[0].load_url)
        this.$store.commit('fwqIp', resUrl.data[0].fwq_ip)
        this.$store.commit('compName', resUrl.data[0].mall_name)
        // this.$store.commit('soft_bb', resUrl.data[0].soft_bb)
        if (resUrl.data[0].soft_bb && resUrl.data[0].soft_bb == '餐饮3.0') {
          this.$store.commit('softVer', '餐饮')
        } else if (resUrl.data[0].soft_bb && resUrl.data[0].soft_bb == '零售5.0') {
          this.$store.commit('softVer', '零售')
        } else {
          this.$store.commit('softVer', resUrl.data[0].soft_bb)
        }
        // }
        let res = await this.api.smCommon.fGetMallInfo({
          oper: 'MALL_SIM_LIST',
          mallId: '00010001', //登录时获取所有区域门店 内部使用必传
          pageSize: '300',
          nowPage: '1'
        })
        if (res.length < 1) {
          return this.errMsg.shMallId = '该手机号下无门店信息'
        }
        this.mallList = res.data
        if (type == 'mr') {
          this.login.shMallId = this.mallList[0].mall_id
          this.$store.commit('shMallId', this.mallList[0].mall_id)
          this.$store.commit('shMallName', this.mallList[0].mall_name)
        }

        // else {
        //   this.errMsg.shMallId = ''
        // }
      },
      fChgMall(e) {
        let obj = {};
        obj = this.mallList.find((item) => {
          return item.mall_id === e; //筛选出匹配数据
        });
        this.$store.commit('shMallId', obj.mall_id)
        this.$store.commit('shMallName', obj.mall_name)
        if (this.active == '普通登录') {
          this.$nextTick(() => {
            this.$refs.userId.focus()
          })
        }

      },
      // 登录
      async fLogin() {
        //验证手机号
        if (this.api.smCom.fSmIsEmpty(this.login.shPhone)) {
          return this.errMsg.shPhone = '请输入手机号'
        } else {
          this.errMsg.shPhone = ''
        }
        // //验证门店
        // if (this.api.smCom.fSmIsEmpty(this.login.shPhone)) {
        //   return this.errMsg.shPhone = '请选择门店'
        // } else {
        //   this.errMsg.shPhone = ''
        // }
        //登录方式
        if (this.active == '普通登录') {
          if (this.api.smCom.fSmIsEmpty(this.login.userId)) {
            return this.errMsg.userId = '请输入员工工号'
          } else {
            this.errMsg.userId = ''
          }
          if (this.api.smCom.fSmIsEmpty(this.login.userPsw)) {
            return this.errMsg.userPsw = '请输入员工密码'
          } else {
            this.errMsg.userPsw = ''
          }
        }
        if (this.active == '快捷登录') {
          if (this.api.smCom.fSmIsEmpty(this.login.yzm)) {
            return this.errMsg.yzm = '验证码不能为空'
          } else {
            return this.errMsg.yzm = '验证码不正确'
          }
        }
        if (!this.isAgree) {
          this.$message('请阅读并同意用户协议')
        }
        if (this.api.smCom.fSmIsEmpty(this.$store.state.softVer)) {
          return this.login.shPhone = ''
        }
        if (this.$store.state.softVer != '零售' && this.$store.state.softVer != '餐饮') {
          return this.$message('版本不正确')
        }
        //获取公司名称
        // if (this.api.smCom.fSmIsEmpty(this.$store.state.smSellAdmin.compName)) {
        let resUrl = await this.fGetMainSrvMchInfo()
        if (resUrl.result != "sucess") {
          return this.$message.error(resUrl.msg)
        }
        if (this.api.smCom.fSmIsEmpty(resUrl.data[0].load_url)) {
          return this.$message.error('获取商户地址失败')
        }
        //储存url和手机号至本地
        this.$store.commit('shPhone', this.login.shPhone)
        this.$store.commit('shLoadUrl', resUrl.data[0].load_url)
        this.$store.commit('fwqIp', resUrl.data[0].fwq_ip)
        this.$store.commit('compName', resUrl.data[0].mall_name)
        // }

        //发送登录请求
        let res = await this.fUserLogin()
        if (res.result != "sucess") {
          if (res.sub_msg == "time_over") {
            this.$store.commit('partnerPhone', res.partner_phone)
            this.$store.commit('shop_show_payqr_yn', res.partner_info[0].shop_show_payqr_yn)
            this.$store.commit('free_yn', res.partner_info[0].free_yn)
            this.$store.commit('create_day', res.user_info[0].create_day)
            this.$store.commit('fy_money', res.user_info[0].fy_money)
            this.$store.commit('userId', this.login.userId)
            this.$store.commit('areaId', res.user_info[0].area_id)
            this.$store.commit('userName', res.user_info[0].user_name)
            sessionStorage.setItem('smSellAdminToken', res.token)
            this.showMallRebew = true
            this.canClose = 'N'
            return
          }
          return this.$message.error(res.msg)
        }
        this.$store.commit('customEx', res.custom_ex)
        this.$store.commit('partnerPhone', res.partner_phone)
        this.mallStopDay = res.user_info[0].stop_day
        this.$store.commit('shop_show_payqr_yn', res.partner_info[0].shop_show_payqr_yn)
        this.$store.commit('free_yn', res.partner_info[0].free_yn)
        this.$store.commit('fy_money', res.user_info[0].fy_money)
        this.$store.commit('create_day', res.user_info[0].create_day)
        this.$store.commit('ws_yn', res.user_reg_info[0].ws_yn)

        this.$store.commit('elabelMchId', res.user_info[0].elabel_mch_id)
        // this.$store.commit('elabelUrl', 'https://www.sanmibox.com/api/smTest2')



        // 判断到期   强制续费
        if (Number(res.user_info[0].stop_day) <= 0) {
          this.showMallRebew = true
          this.canClose = 'N'
          return
        }
        //payWay
        if (res.online_sk_zh_info && res.online_sk_zh_info.length > 0) {
          this.$store.commit('payWay', res.online_sk_zh_info[0].zh_name)
        }

        //储存用户Id和token
        this.$store.commit('userId', this.login.userId)
        this.$store.commit('userName', res.user_info[0].user_name)
        this.$store.commit('areaId', res.user_info[0].area_id)

        // this.$store.commit('smSellAdminToken', res.token)
        sessionStorage.setItem('smSellAdminToken', res.token)
        if (this.login.shPhone.substr(this.login.shPhone.length - 4, 4) == this.login.userPsw) {
          this.changePassword = true
          this.oldPassword = this.login.userPsw
          return
        }
        this.$store.commit('partnerPhone', res.partner_phone)
        // this.$store.commit('vipOption', res.vip_option[0])
        this.$store.commit('systemOption', res.system_option)
        //是否启用颜色尺码
        if (this.$store.state.smSellAdmin.systemOption) {
          let idx = this.$store.state.smSellAdmin.systemOption.findIndex(item => {
            return item.param_name == 'color_yn'
          })
          let idx1 = this.$store.state.smSellAdmin.systemOption.findIndex(item => {
            return item.param_name == 'size_yn'
          })
          if (idx == -1 || idx1 == -1) {
            this.$store.commit('colorSizeYn', 'N')
          } else {
            if (this.$store.state.smSellAdmin.systemOption[idx].param_value == 'N' ||
              this.$store.state.smSellAdmin.systemOption[idx1].param_value == 'N') {
              // return this.$message('系统暂未启用颜色或尺码')
              this.$store.commit('colorSizeYn', 'N')
              // this.colorSizeYn = 'N'
            } else {
              this.$store.commit('colorSizeYn', 'Y')
              // this.colorSizeYn = 'Y'
            }
          }


        }

        let resQx = await this.fGetUserClsQx(res.user_info[0].cls_id)
        if (resQx.result != "sucess") {
          return this.$message(resQx.msg)
        }
        this.$store.commit('qxList', resQx.data)
        let resPower = await this.api.smCommon.fGetSmMenuQx('查看进价')
        if (resPower.resolve == false) {
          this.$store.commit('canSeeJj', false)
        } else {
          this.$store.commit('canSeeJj', true)
        }
        let resPower1 = await this.api.smCommon.fGetSmMenuQx('查看毛利')
        if (resPower1.resolve == false) {
          this.$store.commit('canSeeMl', false)
        } else {
          this.$store.commit('canSeeMl', true)
        }
        this.fgh()
        this.cun()
        this.chuan()
        // 判断到期  七天之内 可以继续使用
        if (Number(res.user_info[0].stop_day) <= 7 && Number(res.user_info[0].stop_day) >= 1 && this.canLogin ==
          'N') {
          this.$confirm('云存储空间还剩' + res.user_info[0].stop_day + '天是否立即续费', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            this.showMallRebew = true
            this.canLogin = 'Y'
          }).catch(() => {
            if (this.$store.state.softVer == '餐饮') {
              this.$router.push('survey')
            } else {
              this.$router.push('mydesktop')
            }
          });
          return
        }
        this.$store.commit('shop_app_info', res.shop_app_info || [])
        if (this.$store.state.softVer == '餐饮') {
          this.$router.push('survey')
        } else {
          this.$router.push('mydesktop')
        }
      },
      //续费
      fCloseRenew() {
        this.showMallRebew = false
        // this.$router.push('survey')
        this.fLogin()
      },
      // 存储默认信息【时间】
      async fgh() {
        this.closingDate = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) +
          ' 23:59:59'
        ];
        this.listDateIndex = 0
        this.$store.commit('setTimeData', this.closingDate)
        this.$store.commit('setListDateIndex', this.listDateIndex)
      },
      // 【门店】
      async cun() {
        if (this.fei == 1) {
          this.valueStore = this.login.shMallId
          this.fei == 2
        }
        this.$store.commit('setValueStore', this.valueStore)
      },
      // 【收银员&导购】
      async chuan() {
        let san = '1'
        this.radio = san
        this.$store.commit('setRadio', this.radio)
      },
      // 修改密码=确定
      async determineAdd() {
        if (this.newPassword == this.confirmPassword) {
          let res = await this.fUserChgPsw()
          if (res.result != "sucess") {
            return this.$message(res.msg)
          }
          this.$message(res.msg);
          this.changePassword = false
          this.login.userPsw = this.newPassword
        } else {
          this.$message('确认密码与修改的密码不一至！');
        }
      },
      // 发送请求 =============================================
      // USER_LOGIN
      // GET_MALL_INFO
      // {
      //         "MALL_ID": this.login.shMallId,
      //         "USER_ID": "1001",
      //         "USER_PSW": "1001"
      //     }
      //获取主服务器商户信息
      async fGetMainSrvMchInfo(oper, shPhone) {
        let js = {};
        js['OPER'] = 'LOAD_URL';
        js['SH_PHONE'] = this.login.shPhone;
        let res = await this.api.smSellApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js)
        console.log(res)
        return res;
      },

      //员工登录
      async fUserLogin(obj) {
        let js = {};
        js['MALL_ID'] = this.login.shMallId
        js['USER_ID'] = this.login.userId
        js['USER_PSW'] = this.login.userPsw
        if (this.$store.state.softVer == '零售') {
          js["SOFT_VER"] = 'smSell5.0'
        } else if (this.$store.state.softVer == '餐饮') {
          js["SOFT_VER"] = 'smCy3.0'
        }
        js['QX_LIST'] = 'sellManger';
        let res = await this.api.smSellApi.fPostToSmSellAdminApi('USER_LOGIN', js, '5837')
        console.log(res)
        return res;
      },
      //获取员工权限
      async fGetUserClsQx(id) {
        let js = {};
        js['OPER'] = 'QX_LIST';
        js['USER_CLS_ID'] = id;
        let res = await this.api.smSellApi.fPostToSmSellQueryApi('GET_USER_CLS_QX', js)
        return res;
      },
      // 修改密码  USER_CHG_PSW
      async fUserChgPsw(oper) {
        let js = {};
        js['USER_ID'] = this.$store.state.smSellAdmin.userId
        js['OLD_PSW'] = this.oldPassword
        js['NEW_PSW'] = this.newPassword
        let res = await this.api.smSellApi.fPostToSmSellAdminApi('USER_CHG_PSW', js)
        return res;
      },
      // 请求结束 ===============================================
    },

  }
</script>

<style lang="less" scoped="scoped">
  .err {
    color: #F56C6C;
  }



  /deep/.el-button--primary:active {
    opacity: 0.8;
  }


  .isActive,
  /deep/ .el-button--primary,
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #5890FF;
    border-color: #5890FF;
    color: #FFFFFF;
  }

  // 重置弹框样式
  /deep/ .el-dialog__header {
    padding: 0 !important;
  }

  /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  .login {
    width: 100vw;
    min-width: 1024px;
    height: 100vh;
    min-height: 768px;
    background: url(../assets/img/login_bgm.png) no-repeat;
    background-size: 100% 100%;
    padding: 80px 0;

    // padding: 60px 80px;
    .left-login {

      // padding-top:12vh;
      .login-box {
        border-radius: 10px;
        width: 400px;
        height: 500px;
        padding: 25px 30px;
      }

      /deep/.el-input__prefix {
        font-size: 18px;
      }

      /deep/.el-input__inner {
        height: 40px;
        font-size: 16px;
        padding-left: 35px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue